export class AppendSapEventInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "kind",
            "baseName": "kind",
            "type": "SapEventKind",
            "format": ""
        },
        {
            "name": "message",
            "baseName": "message",
            "type": "string",
            "format": ""
        },
        {
            "name": "objectId",
            "baseName": "objectId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AppendSapEventInput.attributeTypeMap;
    }
    constructor() {
    }
}
